const ROUTE_NAMES = {
  HOME: 'home',
  HOME_SECURE: 'home-secure',
  FAMILIES_LIST: 'families-list',
  FAMILY: 'family',
  FAMILY_CHOICE_FORM: 'family-choice-form',
  THANKS: 'thanks',
  NOT_FOUND: 'not-found'
}

Object.freeze(ROUTE_NAMES)

export default ROUTE_NAMES
